export default "__VITE_ASSET__d82BdWGN__"